import {faCheck, faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useCallback, useEffect, useState} from 'react';
import LinkCandidateProfile from '../../../../../../components/LinkCandidateProfile';
import Popup from '../../../../../../components/Popup';
import './styles.css';

const RatingInformationPopup = ({ show = false, onClose, data, user }) => {
  const [open, setOpen] = useState(show);
  const dismiss = useCallback(() => {
    setOpen(false);

    if (onClose) {
      onClose(false);
    }
  }, []);

  useEffect(() => {
    setOpen(show);
  }, [show]);


  if (!open) return null;

  return (
    <Popup
      className={'rating-popup'}
      actions={{ dismiss }}
      bodyRender={(
        <div className="rating-popup__inner">
          <div className="rating-popup__header">
            <div className="rating-popup__recruiter">
              {data.CandidateID ? (
                <LinkCandidateProfile
                  cls="rating-information__name"
                  user={user}
                  id={data.CandidateID}
                  name={data.FullName}
                  viewProfile={true}
                />
              ) : (
                <strong>{data.FullName}</strong>
              )}
            </div>
            <div className="rating-popup__rate">{data.Rate}</div>
            <div className="rating-popup__date">{data.RateDate}</div>
          </div>
          <ul className="rating-information__checklist">
            <li className="rating-information__check">
              <span className="rating-information__icon">
                {Number(data.Met) === 1 ? (
                  <FontAwesomeIcon icon={faCheck} color="#f40" size="lg"/>
                ) : (
                  <FontAwesomeIcon icon={faTimes} color="#27282d" size="lg"/>
                )}
              </span>

              <span className="rating-information__value">Met candidate</span>
            </li>
            <li className="rating-information__check">
              <span className="rating-information__icon">
                {Number(data.Spoke) === 1 ? (
                  <FontAwesomeIcon icon={faCheck} color="#f40" size="lg"/>
                ) : (
                  <FontAwesomeIcon icon={faTimes} color="#27282d" size="lg"/>
                )}
              </span>
              <span className="rating-information__value">Spoke to Candidate</span>
            </li>
          </ul>
          <div className="rating-popup__body" dangerouslySetInnerHTML={{__html: data.RatingNotesHtml}} />
        </div>
      )}
      modeless={true}
      dismissWhenClose={true}
      hasCloseButton={true}
    />
  );
};

export default RatingInformationPopup;
